import dynamic from "next/dynamic";

export const DynamicFooter005 = dynamic(() => import("./Footer005"), {
  suspense: true,
});
